import { DialogComponent } from '@theme/dialog';

// eteamsys: popup précommande, rendered by snippets/preorder-popup.liquid

/** Overlay of the CommonNinja popups (age verification in sections/header-group.json). */
const AGE_GATE_SELECTOR = '.nindo-popup-overlay';
const AGE_GATE_POLL_INTERVAL = 500;

/** Products whose popup already opened during this page load, so a re-render doesn't reopen it. */
const openedProductIds = new Set();

/**
 * Pre-order popup that opens automatically on the product page.
 * It waits for the age verification popup to be closed so it doesn't cover it.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog – The dialog element.
 *
 * @extends DialogComponent
 */
class PreorderPopup extends DialogComponent {
  /** @type {number | undefined} */
  #pollTimeout;

  connectedCallback() {
    super.connectedCallback();

    if (Shopify.designMode) return;
    // Rendered inside another dialog, e.g. the quick add modal on collection pages
    if (this.parentElement?.closest('dialog')) return;
    if (openedProductIds.has(this.productId)) return;

    if (document.readyState === 'complete') {
      this.#openWhenAgeGateClosed();
    } else {
      window.addEventListener('load', this.#openWhenAgeGateClosed, { once: true });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('load', this.#openWhenAgeGateClosed);
    clearTimeout(this.#pollTimeout);
  }

  #openWhenAgeGateClosed = () => {
    const ageGate = document.querySelector(AGE_GATE_SELECTOR);

    if (ageGate?.checkVisibility()) {
      this.#pollTimeout = setTimeout(this.#openWhenAgeGateClosed, AGE_GATE_POLL_INTERVAL);
      return;
    }

    openedProductIds.add(this.productId);
    this.showDialog();
  };

  /**
   * @returns {string} The id of the product the popup belongs to.
   */
  get productId() {
    return this.dataset.productId ?? '';
  }
}

if (!customElements.get('preorder-popup')) customElements.define('preorder-popup', PreorderPopup);
